import { http } from "../http";

export interface Exchange {
    trnRequestType: string;
    PMTCUSTID: string;
    CUSTCIF: string;
    CUSTACCFROM: string;
    SELLAMOUNT: number;
    CUSTACCTO: string;
    PURCHAMOUNT: number;
    RATE: number;
    PMTDET: number;
    // COMMAMOUNT: number;
    BENEFACCTYPE: string;
    BENEFNAME: string;
    NOTE: string;
};


export const makeExchange = async (transfer: Exchange): Promise<Exchange> => {
    const { data } = await http.post<Exchange>("exchange/makeexchange", transfer);
    return data;
};

